import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined'
import {
  Badge,
  BadgeProps,
  Divider,
  ListItemButton,
  ListItemText,
  styled,
  Typography,
} from '@mui/material'
import { useEffect, useState } from 'react' // import MUI icon

import { getProtectedS3 } from '../../hooks/useS3Storage'
import { ResourceType } from '../types/interface'

const ProfileResources = ({
  resource: { fileKey, name, type },
}: {
  resource: ResourceType
}) => {
  const [protectedFile, setProtectedFile] = useState<string>('')

  const getProtectedFile = async (file: string) => {
    await getProtectedS3(file)
      .then((data) => {
        if (data) {
          setProtectedFile(data.href)
        }
      })
      .catch((err) => console.log(err))
  }

  const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
    '& .MuiBadge-badge': {
      border: `2px solid ${theme.palette.background.paper}`,
      padding: '0 8px',
      right: -24,
      top: 13,
    },
  }))

  useEffect(() => {
    getProtectedFile(`profile/${fileKey}`)
  }, [fileKey])

  return (
    <>
      <ListItemButton href={protectedFile} target="_blank">
        <ListItemText
          primary={
            <StyledBadge badgeContent={type} color="primary">
              <Typography
                sx={{ textTransform: 'capitalize' }}
                variant="subtitle1"
              >
                {name}
              </Typography>
            </StyledBadge>
          }
        />
        <CloudDownloadOutlinedIcon color="primary" />
      </ListItemButton>
      <Divider component="li" variant="fullWidth" />
    </>
  )
}

export default ProfileResources
